import { IAppState } from '@store';
import { createSelector, createAsyncSelector } from '@flux';


const selectAsyncStatus = createAsyncSelector<PartnerStatus, IAppState>({
	get: state => state.status.main.status,
	selector: createSelector(
		state => state.status.main.status.item,
		item => item,
	),
});

export const mainStatusSelectorsPack = {
	selectAsyncStatus,
};
